import { render } from "./news-category.vue?vue&type=template&id=d005cbe2&scoped=true"
import script from "./news-category.vue?vue&type=script&lang=js"
export * from "./news-category.vue?vue&type=script&lang=js"

import "./news-category.vue?vue&type=style&index=0&id=d005cbe2&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d005cbe2"]])

export default __exports__